import { request } from "./request";

export function register(username, password) {
  return request({
    url: '/user/reg',
    params: {
      username,
      password,
    }
  })
}


export function login(username, password) {
  return request({
    url: '/user/login',
    params: {
      username,
      password,
    }
  })
}


export function queryUser(startIndex, length) {
  return request({
    url:'/user/queryUser',
    params:{
      startIndex,
      length
    }
  })
}


export function totalUser() {
  return request({
    url: '/user/totalUser',
  })
}


export function deleteUser(id) {
  return request({
    url: '/user/deleteUser',
    params: { id }
  })
}


export function modifyUser(id, password ,jno) {
  return request({
    url: '/user/modifyUser',
    params:{ id, password ,jno }
  })
}


export function queryJno(username) {
  return request({
    url: '/user/queryJno',
    params: { username }
  })
}


export function queryUsername(username) {
  return request({
    url: '/user/queryUsername',
    params: { username }
  })
}


export function checkPassword(username, password) {
  return request({
    url: '/user/checkPassword',
    params: { username, password },
  })
}


export function test() {
  return request({
    url: '/user/test'
  })
}